import { useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

const WeatherCard = ({ topText, bottomText, imgSrc, srcSet, overlay }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <li key={`weather-day-${topText}`} className={styles.container}>
      <h3 className={styles.text}>{topText}</h3>
      <div className={styles.iconContainer}>
        <div className={styles.overlayContainer}>{isLoaded && overlay}</div>
        <img onLoad={() => setIsLoaded(true)} className={styles.weatherImage} alt={topText} src={imgSrc} srcSet={srcSet} />
      </div>
      <h4 className={`${styles.text} ${styles.bottomText}`}>{bottomText}</h4>
    </li>
  );
};

WeatherCard.propTypes = {
  topText: PropTypes.string,
  bottomText: PropTypes.string,
  imgSrc: PropTypes.string,
  srcSet: PropTypes.arrayOf(PropTypes.string),
  overlay: PropTypes.element
};

WeatherCard.defaultProps = {
  topText: '',
  bottomText: '',
  imgSrc: '',
  srcSet: [''],
  overlay: <></>
};

export default WeatherCard;
